export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/building.fbc79ec.svg";